import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../components/atoms/button";
import Loading from "../../../components/atoms/loading";
import Select from "../../../components/atoms/select";
import NavBar from "../../../components/organisms/navbar";
import useAuthenticate from "../../../hooks/useAuthenticate";
import api from "../../../services/api";
import { Content, FormContainer, PageDescription, PageTitle } from "../styles";
import SelectFighters from "../../../components/atoms/selectFighters";
import SelectCategories from "src/components/atoms/selectCategories";
import NoOptionsAlert from "../../../components/atoms/no-options-alert";

import para from "../../../data/para.json";
import rulescopaAmizadeDeJiuJitsu2024 from "../../../data/rules-copa-amizade-de-jiu-jitsu-2024.json";


const EnrollmentCopaAmizadeDeJiuJitsu2024 = () => {
  const navigate = useNavigate();
  const { getToken, account } = useAuthenticate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  const modalidade = para;
  const { slug } = useParams();
  let rules = rulescopaAmizadeDeJiuJitsu2024;
  

  const [ages, setAges] = useState<any>([]);
  const [genre, setGenre] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [belts, setBelts] = useState<any>([]);
  const [weights, setWeights] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [fighters, setFighters] = useState<any>([]);
  const [tournament, setTournament] = useState<any>({});
  const [modality, setModality] = useState<any>([]);

  // Estados para controlar mensagens de falta de opções
  const [noCategoriesAvailable, setNoCategoriesAvailable] = useState<boolean>(false);
  const [noWeightsAvailable, setNoWeightsAvailable] = useState<boolean>(false);
  const [noModalityAvailable, setNoModalityAvailable] = useState<boolean>(false);
  const [selectedFighter, setSelectedFighter] = useState<any>(null);

  const [pixData, setPixData] = useState<any>(null);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const getTitleByOption = (array: any[], option: number) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].option === +option) {
        return array[i].title;
      }
    }
    return null;
  };

  const onSubmit = (data: any) => {
    setDisabled(true);
    setLoading(true);
    console.log(data.belt);
    const arrBelts = [
      { title: "branca", option: 1 },
      { title: "cinza", option: 2 },
      { title: "amarela", option: 3 },
      { title: "laranja", option: 4 },
      { title: "verde", option: 5 },
      { title: "azul", option: 6 },
      { title: "roxa", option: 7 },
      { title: "marrom", option: 8 },
      { title: "preta", option: 9 },
    ];


    data.belt = getTitleByOption(arrBelts, data.belt);
    data.age = data.age.toString();
    delete data.fightingAge;

    console.log(data);

    const category =
      (modalidade.find((m: any) => m.option === +data.modalidade)?.title +
        " - " ?? "") + data.category;

    console.log(data);

    console.log({
      age: data.age,
      belt: data.belt,
      genre: data.genre,
      weight: data.weight,
      category: category,
      fightersId: data.fightersId,
    });

    const valueSubscription = rules.filter(r =>  
      r.idade.min <= data.age &&
      r.idade.max >= data.age &&
      r.genero === data.genre &&
      r.faixa.some((f: any) => f.nome === data.belt) &&
      r.peso.descricao === data.weight &&
      r.categoria === data.category
    )[0];

    api
      .post(
        `${"/tournaments/enrollment/" + slug}`,
        {
          age: data.age,
          belt: data.belt,
          genre: data.genre,
          weight: data.weight,
          category: category,
          fightersId: +data.fightersId,
          valueSubscription: String(valueSubscription.valorInscricao)
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((response) => {
      
        toast.success("A sua pre-inscrição foi realizada com sucesso!");
        
        api
      .post(
        "/payments/order",
        {
          enrollmentId: response.data.id
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((res: any) => {
        setLoading(false);
        const qrCode = res.data.qr_codes?.[0];
        if (qrCode) {
          const total = res.data.items?.reduce(
            (sum: number, item: any) => sum + item.unit_amount * item.quantity, 0
          ) || qrCode.amount?.value || 0;

          setPixData({
            qrCodeImage: qrCode.links?.find((l: any) => l.media === 'image/png')?.href,
            qrCodeText: qrCode.text,
            expirationDate: qrCode.expiration_date,
            orderId: res.data.id,
            referenceId: res.data.reference_id,
            totalAmount: total,
            items: res.data.items,
          });
          toast.success("QR Code PIX gerado com sucesso!");
        } else {
          toast.success("Pedido criado com sucesso! ID: " + res.data.id);
          navigate("/");
        }
      }).catch((error) => {
        setDisabled(false);
        setLoading(false);
        toast.error(
          error.response.data.message ||
            "Não foi possível gerar o pagamento!"
        );
      });
      })
      .catch((error) => {
        setDisabled(false);
        setLoading(false);
        toast.error(
          error.response.data.message ||
            "Não foi possível gerar a sua pré-inscrição!"
        );
      });
  };

  useEffect(() => {
    api
      .get("/fighters", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);
        setFighters([
          {
            id: "",
            name: "Selecione uma opção",
          },
          {
            id: 0,
            name: `${account.name}`,
          },
          ...data,
        ]);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Não foi carregar os dados.");
      });

    api.get("tournaments/" + slug).then(({ data }) => {
      setTournament(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  let acc: any = account;
  let formattedGenre: String;

  let weightsSerialize: any = [];
  let categoriesSerialize: any = [];

  let arrCategories: any = [];
  let arrWeights: any = [];

  let fightingAge: Number;

  const handleChange = (e: any) => {
    setValue("category", "");
    setValue("weight", "");
    setValue("modalidade", "");

    setCategories([]);
    setWeights([]);
    setModality([]);
    
    // Resetar mensagens de falta de opções
    setNoCategoriesAvailable(false);
    setNoWeightsAvailable(false);
    setNoModalityAvailable(false);

    let genre: any = [];
    let belts: any = [];

    const arrGenre = [
      { title: "Masculino", option: "masculino" },
      { title: "Feminino", option: "feminino" },
    ];

    const arrBelts = [
      { title: "Branca", option: 1 },
      { title: "Cinza", option: 2 },
      { title: "Amarela", option: 3 },
      { title: "Laranja", option: 4 },
      { title: "Verde", option: 5 },
      { title: "Azul", option: 6 },
      { title: "Roxa", option: 7 },
      { title: "Marrom", option: 8 },
      { title: "Preta", option: 9 },
    ];
    // eslint-disable-next-line eqeqeq
    if (e.target.value == 0) {
      //============================== Genero ==============================
      genre = arrGenre.filter(
        (t) => t.option.toLowerCase() === acc.genre.toLowerCase()
      );

      formattedGenre = genre[0]?.option.toLowerCase();
      //============================== Idade ==============================
      // donst work with a valid date
      // // donst work with a valid date
      // const dateOfTournament = +tournament.date.replace(/\//g, "-").split("-")[0];

      const dateOfTournament = new Date().getFullYear();
      const birthFightFromFighter = +acc.birth_date
        .replace(/\//g, "-")
        .split("-")[2];
      fightingAge = dateOfTournament - birthFightFromFighter;

      //============================== Faixa ==============================
      belts = arrBelts.filter((b) => b.option === acc.belt);
      setSelectedFighter(acc);
      //============================== Categoria ==============================
      // eslint-disable-next-line array-callback-return
      rules.map((item) => {
        if (
          item.idade.max >= +fightingAge &&
          item.idade.min <= +fightingAge &&
          item.genero === formattedGenre &&
          item.faixa.filter(
            (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
          ).length
        ) {
          arrCategories.push({
            item: item.categoria,
            min: item.idade.min,
            max: item.idade.max,
            maxDescricao: item.idade.maxParaDescricao,
            minDescricao: item.idade.minParaDescricao,
          });
        }
      });
      const uniqueArray = [];
      const itemSet = new Set();

      for (const obj of arrCategories) {
        if (!itemSet.has(obj.item)) {
          itemSet.add(obj.item);
          uniqueArray.push(obj);
        }
      }

      categoriesSerialize = [...new Set(uniqueArray)].map((category: any) => {
        return {
          title:
            `${category.item} - ${category.minDescricao} até ${category.maxDescricao} anos`.toUpperCase(),
          option: category.item,
        };
      });

      setValue("age", +fightingAge);
      setValue("category", "");
    } else {
      // ============================== Fighters ==============================
      // eslint-disable-next-line eqeqeq
      const fightersFilter: any = fighters.filter(
        (f: any) => +f.id === +e.target.value
      );
      setSelectedFighter(fightersFilter[0]);
      //============================== Genero ==============================
      genre = arrGenre.filter(
        (t) => t.title.toLowerCase() === fightersFilter[0].genre.toLowerCase()
      );

      formattedGenre = genre[0].title.toLowerCase();
      //============================== Idade ==============================

      // donst work with a valid date
      // const dateOfTournament = +tournament.date.replace(/\//g, "-").split("-")[0];
      const dateOfTournament = new Date().getFullYear();
      const birthFightFromFighter = +fightersFilter[0].birth_date
        .replace(/\//g, "-")
        .split("-")[2];
      fightingAge = dateOfTournament - birthFightFromFighter;
      //============================== Faixa ==============================
      belts = arrBelts.filter((b) => b.option === fightersFilter[0].belt);
      //============================== Categoria ==============================
      // eslint-disable-next-line array-callback-return
      rules.map((item) => {
        if (
          item.idade.max >= +fightingAge &&
          item.idade.min <= +fightingAge &&
          item.genero === formattedGenre &&
          item.faixa.filter(
            (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
          ).length
        ) {
          arrCategories.push({
            item: item.categoria,
            min: item.idade.min,
            max: item.idade.max,
            maxDescricao: item.idade.maxParaDescricao,
            minDescricao: item.idade.minParaDescricao,
          });
        }
      });

      const uniqueArray = [];
      const itemSet = new Set();

      for (const obj of arrCategories) {
        if (!itemSet.has(obj.item)) {
          itemSet.add(obj.item);
          uniqueArray.push(obj);
        }
      }

      categoriesSerialize = [...new Set(uniqueArray)].map((category: any) => {
        return {
          title:
            `${category.item} - ${category.minDescricao} até ${category.maxDescricao} anos`.toUpperCase(),
          option: category.item,
        };
      });

      setValue("category", "");
    }

    // Verificar se há categorias disponíveis
    if (categoriesSerialize.length === 0) {
      setNoCategoriesAvailable(true);
      toast.warning("Não há categorias disponíveis para este atleta com base nos filtros aplicados.");
    }

    setGenre([...genre]);
    setAges([{ title: fightingAge, option: fightingAge }]);
    setBelts([...belts]);
    setTimeout(() => {
      setValue("genre", genre[0]?.option);
      setValue("age", fightingAge);
      setValue("belt", belts[0]?.option);
    }, 100);
    setCategories([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerialize,
    ]);
  };

  //============================== Peso ==============================
  const handleChangeWeights = (e: any) => {
    setValue("weight", "");
    setNoWeightsAvailable(false);
    
    // eslint-disable-next-line array-callback-return
    rules.map((item) => {
      if (
        item.idade.max >= +ages[0].option &&
        item.idade.min <= +ages[0].option &&
        item.genero === genre[0].title.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrWeights.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    
        weightsSerialize = [...new Set(arrWeights)].map((category: any) => {
          console.log(category);
          return {
            title: `${category.peso} - ${category.massa} kg`.toUpperCase(),
            option: category.peso,
          };
        });
    
    // Verificar se há pesos disponíveis
    if (weightsSerialize.length === 0) {
      setNoWeightsAvailable(true);
      toast.warning("Não há faixas de peso disponíveis para esta categoria.");
    }

    setWeights([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerialize,
    ]);
  };

 
  function handleChangeClasses(e: any) {
    console.log(">>>>>testfunc>>>>>>>", modalidade)
    setModality([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...modalidade,
    ]);
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Limpeza do evento ao desmontar o componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const [payingOrder, setPayingOrder] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutos em segundos
  const [expired, setExpired] = useState(false);
  const [checkingPayment, setCheckingPayment] = useState(false);

  // Timer countdown
  useEffect(() => {
    if (!pixData || paymentSuccess) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [pixData, paymentSuccess]);

  // Polling para verificar se o pagamento foi confirmado via webhook do PagBank
  useEffect(() => {
    if (!pixData || paymentSuccess || expired) return;

    const enrollmentId = pixData.referenceId?.replace("INSC_", "");

    const pollInterval = setInterval(() => {
      setCheckingPayment(true);
      api
        .get(`/payments/order/status/${enrollmentId}`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        })
        .then((res: any) => {
          setCheckingPayment(false);
          if (res.data?.paid) {
            clearInterval(pollInterval);
            setPaymentSuccess(true);
            toast.success("Pagamento confirmado pelo PagBank!");
          }
        })
        .catch(() => {
          setCheckingPayment(false);
        });
    }, 1000); // Verifica a cada 1 segundo (ambiente de teste)

    return () => clearInterval(pollInterval);
  }, [pixData, paymentSuccess, expired]);

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  const timerColor = timeLeft <= 60 ? '#f44336' : timeLeft <= 180 ? '#ff9800' : '#4CAF50';

  const handleCopyPix = () => {
    if (pixData?.qrCodeText) {
      navigator.clipboard.writeText(pixData.qrCodeText);
      toast.success("Código PIX copiado!");
    }
  };

  // No sandbox do PagBank, o pagamento PIX é simulado automaticamente:
  // - Até R$100: pago instantaneamente
  // - R$100,01 a R$200: pago com delay de 5 minutos
  // - Acima de R$200: fica aguardando (não paga)

  if (loading)
    return <Loading text="Aguarde, estamos processando a sua pré-inscrição." />;

  // Tela de pagamento confirmado
  if (paymentSuccess && pixData) {
    const enrollmentId = pixData.referenceId?.replace("INSC_", "") || "";
    return (
      <div>
        <NavBar />
        <Content>
          <div style={{
            padding: '40px',
            backgroundColor: '#fff',
            borderRadius: '10px',
            textAlign: 'center',
            maxWidth: '500px',
            margin: '0 auto',
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: '#4CAF50',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
            }}>
              <span style={{ fontSize: '40px', color: '#fff' }}>&#10003;</span>
            </div>

            <h2 style={{ marginBottom: '10px', color: '#333' }}>
              Pagamento confirmado!
            </h2>

            <p style={{ color: '#666', marginBottom: '8px', fontSize: '16px' }}>
              O pagamento da inscrição <strong>N.{enrollmentId}</strong> foi realizado com sucesso.
            </p>

            <p style={{ color: '#999', marginBottom: '30px', fontSize: '14px' }}>
              Pedido: {pixData.orderId}
            </p>

            <div style={{
              backgroundColor: '#e8f5e9',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '30px',
            }}>
              <p style={{ color: '#2e7d32', fontSize: '14px', margin: 0 }}>
                Valor pago: <strong>R$ {((pixData.totalAmount || 0) / 100).toFixed(2).replace('.', ',')}</strong>
              </p>
            </div>

            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px', fontWeight: 500 }}>
              Deseja realizar uma nova inscrição?
            </p>

            <button
              onClick={() => {
                setPixData(null);
                setPaymentSuccess(false);
                setTimeLeft(600);
                setExpired(false);
                setDisabled(false);
              }}
              style={{
                backgroundColor: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '14px 30px',
                fontSize: '16px',
                cursor: 'pointer',
                width: '100%',
                marginBottom: '12px',
              }}
            >
              Sim, fazer nova inscrição
            </button>

            <button
              onClick={() => navigate("/")}
              style={{
                backgroundColor: 'transparent',
                color: '#666',
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '12px 30px',
                fontSize: '14px',
                cursor: 'pointer',
                width: '100%',
              }}
            >
              Não, voltar para a página inicial
            </button>
          </div>
        </Content>
      </div>
    );
  }

  // Tela do QR Code PIX com timer
  if (pixData) {
    return (
      <div>
        <NavBar />
        <Content>
          <div style={{
            padding: '40px',
            backgroundColor: '#fff',
            borderRadius: '10px',
            textAlign: 'center',
            maxWidth: '500px',
            margin: '0 auto',
          }}>
            <h2 style={{ marginBottom: '10px' }}>Pagamento via PIX</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              Escaneie o QR Code ou copie o código para pagar
            </p>

            {/* Timer circular */}
            <div style={{
              position: 'relative',
              width: '100px',
              height: '100px',
              margin: '0 auto 15px',
            }}>
              <svg width="100" height="100" viewBox="0 0 100 100">
                {/* Fundo cinza */}
                <circle
                  cx="50" cy="50" r="45"
                  fill="none"
                  stroke="#e0e0e0"
                  strokeWidth="6"
                />
                {/* Progresso */}
                <circle
                  cx="50" cy="50" r="45"
                  fill="none"
                  stroke={timerColor}
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeDasharray={`${2 * Math.PI * 45}`}
                  strokeDashoffset={`${2 * Math.PI * 45 * (1 - timeLeft / 600)}`}
                  transform="rotate(-90 50 50)"
                  style={{ transition: 'stroke-dashoffset 1s linear, stroke 0.5s' }}
                />
              </svg>
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '20px',
                fontWeight: 'bold',
                color: timerColor,
                fontFamily: 'monospace',
              }}>
                {formatTime(timeLeft)}
              </div>
            </div>

            {expired ? (
              <p style={{ color: '#f44336', fontWeight: 'bold', marginBottom: '20px' }}>
                QR Code expirado! Faça uma nova inscrição.
              </p>
            ) : (
              <p style={{ color: '#999', fontSize: '13px', marginBottom: '15px' }}>
                Tempo restante para pagamento
              </p>
            )}

            {pixData.qrCodeImage && !expired && (
              <img
                src={pixData.qrCodeImage}
                alt="QR Code PIX"
                style={{
                  width: '250px',
                  height: '250px',
                  marginBottom: '20px',
                  opacity: expired ? 0.3 : 1,
                }}
              />
            )}

            {!expired && (
              <>
                <div style={{
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  padding: '15px',
                  marginBottom: '20px',
                  wordBreak: 'break-all',
                  fontSize: '12px',
                  color: '#333',
                  maxHeight: '100px',
                  overflow: 'auto',
                }}>
                  {pixData.qrCodeText}
                </div>

                <button
                  onClick={handleCopyPix}
                  style={{
                    backgroundColor: '#4CAF50',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 30px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    width: '100%',
                    marginBottom: '15px',
                  }}
                >
                  Copiar código PIX
                </button>

                {checkingPayment && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    backgroundColor: '#fff3e0',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '15px',
                  }}>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '3px solid #ff9800',
                      borderTop: '3px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                    }} />
                    <span style={{ color: '#e65100', fontSize: '14px' }}>
                      Aguardando confirmação do pagamento...
                    </span>
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                  </div>
                )}
              </>
            )}

            <button
              onClick={() => navigate("/")}
              style={{
                backgroundColor: 'transparent',
                color: '#666',
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '10px 30px',
                fontSize: '14px',
                cursor: 'pointer',
                width: '100%',
                marginTop: '10px',
              }}
            >
              Voltar para a página inicial
            </button>
          </div>
        </Content>
      </div>
    );
  }

  return (
    <div>
      <NavBar />

      <Content>
        <FormContainer onSubmit={handleSubmit(onSubmit)}>
          <PageTitle>Inscrição</PageTitle>
          <PageDescription>
            Essa inscrição é referente ao torneio:{" "}

            {tournament.name}
          </PageDescription>

          <SelectFighters
            label="Escolha um atleta para esse evento"
            name="fightersId"
            register={register}
            hasError={!!errors.category}
            required
            error="Este campo é obrigatório"
            options={fighters}
            onChange={handleChange}
          />

          <NoOptionsAlert
            show={noCategoriesAvailable && !!selectedFighter}
            type="categories"
            fighterData={{
              name: selectedFighter?.name || "",
              age: ages[0]?.option,
              gender: genre[0]?.title,
              belt: belts[0]?.title,
            }}
          />

          <Select
            label="Sexo"
            name="genre"
            register={register}
            required
            hasError={!!errors.genre}
            error="Este campo é obrigatório"
            options={genre}
          />

          <Select
            label="Idade de luta"
            name="age"
            register={register}
            required
            hasError={!!errors.age}
            error="Este campo é obrigatório"
            options={ages}
          />

          <Select
            label="Faixa"
            name="belt"
            register={register}
            required
            hasError={!!errors.belt}
            error="Este campo é obrigatório"
            options={belts}
          />

          <SelectCategories
            label="Categoria"
            name="category"
            register={register}
            required
            hasError={!!errors.category}
            error="Este campo é obrigatório"
            options={categories}
            onChange={handleChangeWeights}
          />

          <NoOptionsAlert
            show={noWeightsAvailable}
            type="weights"
            categoryName={watch("category")}
          />

          <SelectCategories
            label="Peso"
            name="weight"
            register={register}
            required
            hasError={!!errors.category}
            error="Este campo é obrigatório"
            options={weights}
            onChange={handleChangeClasses}
          />

          <SelectCategories
            label="Classificação Funcional"
            name="modalidade"
            register={register}
            required
            hasError={!!errors.modalidade}
            error="Este campo é obrigatório"
            options={modality}
          />

          <Button type="submit" label="Inscrever" disabled={disabled} />
        </FormContainer>
      </Content>
    </div>
  );
};

export default EnrollmentCopaAmizadeDeJiuJitsu2024;

